import { Modal } from "react-bootstrap";
import { ColorDiv } from "../../layout/ColorDiv";
import { Close } from "../../assets/icons/Close";
import { useEffect } from "react";

export function MFModal({
  isOpen,
  onClose,
  children,
  dialogClassName,
  enableTableScroll,
  disableTableScroll,
  localConfigurator,
}) {
  useEffect(() => {
    if (isOpen) {
      disableTableScroll();
    } else {
      enableTableScroll();
    }
  }, [isOpen, disableTableScroll, enableTableScroll]);

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      className="custom-modal"
      dialogClassName={dialogClassName}
    >
      <Modal.Body>
        {/* body: style={{ fontFamily: "Public Sans" }} */}
        <button className="btn-close-modal" onClick={onClose}>
          <span style={{ opacity: 0.4 }}>
            <Close size={20} />
          </span>
        </button>
        <ColorDiv
          interactionColor={
            localConfigurator &&
            localConfigurator.theme &&
            localConfigurator.theme.colors
              ? localConfigurator.theme.colors.primaryText
              : null
          }
        >
          {children}
        </ColorDiv>
      </Modal.Body>
    </Modal>
  );
}
